export default __webpack_public_path__ + "static/media/DualLand.27e2517a.png";